import React from 'react';
import { Component } from "react";
import ControlPreviewLinkButton from './ControlPreviewLinkButton';
import ControlPreviewText from './ControlPreviewText';
import ControlPreviewTextInput from './ControlPreviewTextInput';

class ControlPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      control_type: props.control_type,
      control_id: props.control_id
    };
  }
  componentDidMount() {
  }

    render() {
        switch(this.state.control_type){
            case "#IVySoft.SiteBuilder.App.LinkButton":
                return (<ControlPreviewLinkButton control_id={this.state.control_id} />);

            case "#IVySoft.SiteBuilder.App.Text":
                return (<ControlPreviewText control_id={this.state.control_id} />);
            case "#IVySoft.SiteBuilder.App.TextInput":
                return (<ControlPreviewTextInput control_id={this.state.control_id} />);
            case "#IVySoft.SiteBuilder.App.LinkList":
            case "#IVySoft.SiteBuilder.App.Panel":
            case "#IVySoft.SiteBuilder.App.SubmitButton":
            default:
                return (<div>{this.state.control_type}</div>);
        }
    }
}

export default ControlPreview;